import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import service from '../service';
import { promoCodeQueryKeys } from './usePromoCodes';

export interface DeletePromoCodeVariables {
  id: string;
}

export function useDeletePromoCode(
  options?: UseMutationOptions<void, Error, DeletePromoCodeVariables>,
) {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationKey: ['promoCode', 'delete'],
    mutationFn: async ({ id }: DeletePromoCodeVariables) => {
      return service.deletePromoCode(id);
    },
    retry: (failureCount, error: any) => {
      const status =
        error?.status ??
        error?.response?.status ??
        error?.cause?.status ??
        null;
      const isServerOrNetwork = status == null || status >= 500;
      return failureCount < 2 && isServerOrNetwork;
    },
    ...restOptions,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: promoCodeQueryKeys.all });
      onSuccess?.(data, variables, context, mutation);
    },
  });
}
